import { render, staticRenderFns } from "./add-booking.vue?vue&type=template&id=1c76a07d&"
import script from "./add-booking.vue?vue&type=script&lang=js&"
export * from "./add-booking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports